import React, { FC, ReactElement } from "react";
import { Control, Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { CreateUpdateEntityFormValues } from "../../EntityEditor";

import { InputAdornment, TextField } from "@components/base";

interface OwnershipShare {
  control: Control<CreateUpdateEntityFormValues>;
}

const OwnershipShare: FC<OwnershipShare> = ({ control }) => {
  const { t } = useTranslation();

  return (
    <Controller
      control={control}
      name="ownershipShare"
      render={({
        field: { onBlur, onChange, name, value },
        fieldState: { error },
      }): ReactElement => (
        <TextField
          {...{ onBlur, onChange, name, value }}
          fullWidth
          inputMode="decimal"
          label={t("entitiesManagement.entityEditor.ownershipShare")}
          helperText={error?.message}
          error={Boolean(error)}
          slotProps={{
            input: {
              endAdornment: <InputAdornment position="end">%</InputAdornment>,
            },
          }}
        />
      )}
    />
  );
};

export default OwnershipShare;
